import StandardError from '../StandardError'

export default class UnavailableProductError extends StandardError {
  constructor(errors) {
    super('This product is banned and cannot be added to collections.')
    this.errors = errors
  }
}
